import React, { useState } from 'react';
import './Sidebar.css';
import { useLanguage } from '../../context/LanguageContext';
import { getTranslation } from '../../i18n/translations';

const Sidebar = ({ isOpen, onClose, onNavigate }) => {
  const { language } = useLanguage();
  const [expandedMenus, setExpandedMenus] = useState({
    dashboards: true,
    store: false,
    settings: false,
  });

  const toggleMenu = (menu) => {
    setExpandedMenus((prev) => {
      // If the clicked menu is already open, close it
      if (prev[menu]) {
        return {
          ...prev,
          [menu]: false,
        };
      }
      // Otherwise, close all menus and open only the clicked one
      return {
        dashboards: false,
        store: false,
        settings: false,
        [menu]: true,
      };
    });
  };

  return (
    <div className={`sidebar ${isOpen ? 'open' : ''}`}>
      <div className="sidebar__scrollable">
        <div className="menu-link">
        <div className="menu-link__item">
          <div className="menu-link__title-container" onClick={() => toggleMenu('dashboards')}>
            <p className="menu-link__title">
              <span>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="menu-link__icon-left"
                >
                  <rect
                    x="3"
                    y="3"
                    width="18"
                    height="18"
                    rx="3"
                    stroke="#1570EF"
                    strokeWidth="1.4375"
                  />
                  <path
                    d="M16.5254 16.8249H6.52539V6.9043"
                    stroke="#1570EF"
                    strokeWidth="1.19048"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M16.5254 10.9917L13.1921 13.9084L9.85872 11.4084L6.52539 14.325"
                    stroke="#1570EF"
                    strokeWidth="1.19048"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              {getTranslation('myDashboards', language)}
            </p>
            <p className="menu-link__icon-right">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                style={{
                  transform: expandedMenus.dashboards ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.3s',
                }}
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8 11L3 5.73684L3.7 5L8 9.52632L12.3 5L13 5.73684L8 11Z"
                  fill="#1D2939"
                />
              </svg>
            </p>
          </div>
          {expandedMenus.dashboards && (
            <p className="menu-link__subtitle-group">
              <a href="/" className="menu-link__subtitle selected">
                {getTranslation('mainDashboard', language)}
              </a>
              <a href="/dashboard/rented-asics" className="menu-link__subtitle">
                {getTranslation('rentedAsics', language)}
              </a>
              <a href="/dashboard/purchased-asics" className="menu-link__subtitle">
                {getTranslation('purchasedAsics', language)}
              </a>
            </p>
          )}
        </div>

        <div className="menu-link__item">
          <div className="menu-link__title-container" onClick={() => toggleMenu('store')}>
            <p className="menu-link__title">
              <span>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="menu-link__icon-left"
                >
                  <path
                    d="M19.1647 20H5.83533C5.67296 19.9992 5.51642 19.9387 5.39498 19.8299C5.27354 19.721 5.1955 19.5711 5.17546 19.4083L4.00419 8.74167C3.99377 8.64873 4.00283 8.55462 4.03077 8.46545C4.05871 8.37628 4.10491 8.29404 4.16637 8.22409C4.22783 8.15414 4.30317 8.09804 4.38749 8.05943C4.47181 8.02082 4.56323 8.00058 4.65581 8H20.3442C20.4368 8.00058 20.5282 8.02082 20.6125 8.05943C20.6968 8.09804 20.7722 8.15414 20.8336 8.22409C20.8951 8.29404 20.9413 8.37628 20.9692 8.46545C20.9972 8.55462 21.0062 8.64873 20.9958 8.74167L19.8245 19.4083C19.8045 19.5711 19.7265 19.721 19.605 19.8299C19.4836 19.9387 19.327 19.9992 19.1647 20V20Z"
                    stroke="#1570EF"
                    strokeWidth="1.31522"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 11V8.33333C9 7.44928 9.36875 6.60143 10.0251 5.97631C10.6815 5.35119 11.5717 5 12.5 5C13.4283 5 14.3185 5.35119 14.9749 5.97631C15.6313 6.60143 16 7.44928 16 8.33333V11"
                    stroke="#1570EF"
                    strokeWidth="1.31522"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              {getTranslation('btcMiningStore', language)}
            </p>
            <p className="menu-link__icon-right">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                style={{
                  transform: expandedMenus.store ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.3s',
                }}
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8 11L3 5.73684L3.7 5L8 9.52632L12.3 5L13 5.73684L8 11Z"
                  fill="#1D2939"
                />
              </svg>
            </p>
          </div>
          {expandedMenus.store && (
            <p className="menu-link__subtitle-group">
              <a 
                href="/mining-store/promo" 
                className="menu-link__subtitle"
                onClick={(e) => {
                  e.preventDefault();
                  if (onNavigate) {
                    onNavigate('/mining-store/promo');
                  }
                }}
              >
                Promo
              </a>
              <a 
                href="/mining-store/rent-asics" 
                className="menu-link__subtitle"
                onClick={(e) => {
                  e.preventDefault();
                  if (onNavigate) {
                    onNavigate('/mining-store/rent-asics');
                  }
                }}
              >
                Rent ASICs
              </a>
              <a href="/mining-store/buy-asics" className="menu-link__subtitle">
                Buy ASICs
              </a>
            </p>
          )}
        </div>

        <div className="menu-link__item">
          <div className="menu-link__title-container">
            <a 
              href="/marketplace" 
              className="menu-link__title"
              onClick={(e) => {
                e.preventDefault();
                if (onNavigate) {
                  onNavigate('/marketplace');
                }
              }}
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  className="menu-link__icon-left"
                >
                  <path
                    d="M15 21V15.6C15 15.0399 15 14.7599 14.891 14.546C14.7951 14.3578 14.6422 14.2049 14.454 14.109C14.2401 14 13.9601 14 13.4 14H10.6C10.0399 14 9.75992 14 9.54601 14.109C9.35785 14.2049 9.20487 14.3578 9.10899 14.546C9 14.7599 9 15.0399 9 15.6V21M3 7C3 8.65685 4.34315 10 6 10C7.65685 10 9 8.65685 9 7C9 8.65685 10.3431 10 12 10C13.6569 10 15 8.65685 15 7C15 8.65685 16.3431 10 18 10C19.6569 10 21 8.65685 21 7M6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V6.2C21 5.0799 21 4.51984 20.782 4.09202C20.5903 3.71569 20.2843 3.40973 19.908 3.21799C19.4802 3 18.9201 3 17.8 3H6.2C5.0799 3 4.51984 3 4.09202 3.21799C3.71569 3.40973 3.40973 3.71569 3.21799 4.09202C3 4.51984 3 5.07989 3 6.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z"
                    stroke="#1570EF"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              {getTranslation('marketplace', language)}
            </a>
            <p className="menu-link__icon-right"></p>
          </div>
        </div>

        <div className="menu-link__item">
          <div className="menu-link__title-container" onClick={() => toggleMenu('settings')}>
            <p className="menu-link__title">
              <span>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="menu-link__icon-left"
                >
                  <path
                    d="M12 15C13.1046 15 14 14.1046 14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13C10 14.1046 10.8954 15 12 15Z"
                    stroke="#1570EF"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M18.0545 15.4545C17.9456 15.7013 17.9131 15.9751 17.9613 16.2405C18.0094 16.5059 18.1359 16.7508 18.3245 16.9436L18.3736 16.9927C18.5258 17.1447 18.6465 17.3252 18.7288 17.5238C18.8112 17.7225 18.8536 17.9354 18.8536 18.1505C18.8536 18.3655 18.8112 18.5784 18.7288 18.7771C18.6465 18.9757 18.5258 19.1562 18.3736 19.3082C18.2217 19.4603 18.0412 19.581 17.8425 19.6634C17.6439 19.7457 17.431 19.7881 17.2159 19.7881C17.0009 19.7881 16.7879 19.7457 16.5893 19.6634C16.3906 19.581 16.2102 19.4603 16.0582 19.3082L16.0091 19.2591C15.8163 19.0705 15.5714 18.9439 15.3059 18.8958C15.0405 18.8477 14.7668 18.8802 14.52 18.9891C14.278 19.0928 14.0716 19.265 13.9263 19.4845C13.7809 19.704 13.7029 19.9613 13.7018 20.2245V20.3636C13.7018 20.7976 13.5294 21.2138 13.2225 21.5207C12.9157 21.8276 12.4994 22 12.0655 22C11.6315 22 11.2152 21.8276 10.9084 21.5207C10.6015 21.2138 10.4291 20.7976 10.4291 20.3636V20.29C10.4228 20.0192 10.3351 19.7565 10.1775 19.5362C10.0199 19.3159 9.79969 19.1481 9.54545 19.0545C9.29868 18.9456 9.02493 18.9131 8.75952 18.9613C8.4941 19.0094 8.24919 19.1359 8.05636 19.3245L8.00727 19.3736C7.8553 19.5258 7.67483 19.6465 7.47617 19.7288C7.27752 19.8112 7.06459 19.8536 6.84955 19.8536C6.6345 19.8536 6.42157 19.8112 6.22292 19.7288C6.02426 19.6465 5.84379 19.5258 5.69182 19.3736C5.53967 19.2217 5.41898 19.0412 5.33663 18.8425C5.25428 18.6439 5.21189 18.431 5.21189 18.2159C5.21189 18.0009 5.25428 17.7879 5.33663 17.5893C5.41898 17.3906 5.53967 17.2102 5.69182 17.0582L5.74091 17.0091C5.92953 16.8163 6.05606 16.5714 6.10419 16.3059C6.15231 16.0405 6.11982 15.7668 6.01091 15.52C5.90719 15.278 5.73498 15.0716 5.51547 14.9263C5.29596 14.7809 5.03873 14.7029 4.77545 14.7018H4.63636C4.20237 14.7018 3.78616 14.5294 3.47928 14.2225C3.1724 13.9157 3 13.4994 3 13.0655C3 12.6315 3.1724 12.2152 3.47928 11.9084C3.78616 11.6015 4.20237 11.4291 4.63636 11.4291H4.71C4.98081 11.4228 5.24346 11.3351 5.46379 11.1775C5.68412 11.0199 5.85195 10.7997 5.94545 10.5455C6.05437 10.2987 6.08686 10.0249 6.03873 9.75952C5.99061 9.4941 5.86408 9.24919 5.67545 9.05636L5.62636 9.00727C5.47422 8.8553 5.35352 8.67483 5.27118 8.47617C5.18883 8.27752 5.14644 8.06459 5.14644 7.84955C5.14644 7.6345 5.18883 7.42157 5.27118 7.22292C5.35352 7.02426 5.47422 6.84379 5.62636 6.69182C5.77834 6.53967 5.95881 6.41898 6.15746 6.33663C6.35611 6.25428 6.56905 6.21189 6.78409 6.21189C6.99913 6.21189 7.21207 6.25428 7.41072 6.33663C7.60937 6.41898 7.78984 6.53967 7.94182 6.69182L7.99091 6.74091C8.18374 6.92953 8.42865 7.05606 8.69406 7.10419C8.95948 7.15231 9.23322 7.11982 9.48 7.01091H9.54545C9.78745 6.90719 9.99383 6.73498 10.1392 6.51547C10.2846 6.29596 10.3626 6.03873 10.3636 5.77545V5.63636C10.3636 5.20237 10.536 4.78616 10.8429 4.47928C11.1498 4.1724 11.566 4 12 4C12.434 4 12.8502 4.1724 13.1571 4.47928C13.464 4.78616 13.6364 5.20237 13.6364 5.63636V5.71C13.6374 5.97328 13.7154 6.23051 13.8608 6.45002C14.0062 6.66953 14.2126 6.84174 14.4545 6.94545C14.7013 7.05437 14.9751 7.08686 15.2405 7.03873C15.5059 6.99061 15.7508 6.86408 15.9436 6.67545L15.9927 6.62636C16.1447 6.47422 16.3252 6.35352 16.5238 6.27118C16.7225 6.18883 16.9354 6.14644 17.1505 6.14644C17.3655 6.14644 17.5784 6.18883 17.7771 6.27118C17.9757 6.35352 18.1562 6.47422 18.3082 6.62636C18.4603 6.77834 18.581 6.95881 18.6634 7.15746C18.7457 7.35611 18.7881 7.56905 18.7881 7.78409C18.7881 7.99913 18.7457 8.21207 18.6634 8.41072C18.581 8.60937 18.4603 8.78984 18.3082 8.94182L18.2591 8.99091C18.0705 9.18374 17.9439 9.42865 17.8958 9.69406C17.8477 9.95948 17.8802 10.2332 17.9891 10.48V10.5455C18.0928 10.7874 18.265 10.9938 18.4845 11.1392C18.704 11.2846 18.9613 11.3626 19.2245 11.3636H19.3636C19.7976 11.3636 20.2138 11.536 20.5207 11.8429C20.8276 12.1498 21 12.566 21 13C21 13.434 20.8276 13.8502 20.5207 14.1571C20.2138 14.464 19.7976 14.6364 19.3636 14.6364H19.29C19.0267 14.6374 18.7695 14.7154 18.55 14.8608C18.3305 15.0062 18.1583 15.2126 18.0545 15.4545Z"
                    stroke="#1570EF"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              {getTranslation('generalSettings', language)}
            </p>
            <p className="menu-link__icon-right">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                style={{
                  transform: expandedMenus.settings ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.3s',
                }}
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8 11L3 5.73684L3.7 5L8 9.52632L12.3 5L13 5.73684L8 11Z"
                  fill="#1D2939"
                />
              </svg>
            </p>
          </div>
          {expandedMenus.settings && (
            <p className="menu-link__subtitle-group">
              <a 
                href="/general-settings/settings" 
                className="menu-link__subtitle"
                onClick={(e) => {
                  e.preventDefault();
                  if (onNavigate) {
                    onNavigate('/general-settings/settings');
                  }
                }}
              >
                {getTranslation('settings', language)}
              </a>
              <a 
                href="/general-settings/transactions" 
                className="menu-link__subtitle"
                onClick={(e) => {
                  e.preventDefault();
                  if (onNavigate) {
                    onNavigate('/general-settings/transactions');
                  }
                }}
              >
                {getTranslation('transactions', language)}
              </a>
              <a 
                href="/general-settings/withdrawals" 
                className="menu-link__subtitle"
                onClick={(e) => {
                  e.preventDefault();
                  if (onNavigate) {
                    onNavigate('/general-settings/withdrawals');
                  }
                }}
              >
                {getTranslation('withdrawals', language)}
              </a>
            </p>
          )}
        </div>

        <span className="menu__border"></span>
        </div>

        <div className="icons sidebar__contact">
        <div className="icons__block">
          <button className="icon__svg main-chat-bot-carrot-account">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
            >
              <path
                d="M2.64941 10.4134C2.27646 12.3763 2.60726 14.4054 3.57954 16.1456L2.85332 18.7106C2.79562 18.9095 2.79224 19.1202 2.84356 19.3208C2.89509 19.5222 2.99985 19.7061 3.14688 19.8531C3.2939 20.0001 3.47777 20.1049 3.6792 20.1564C3.87983 20.2078 4.09054 20.2044 4.28941 20.1467L6.85435 19.4205C8.59458 20.3927 10.6237 20.7235 12.5866 20.3506C14.6208 19.9641 16.4439 18.8484 17.7138 17.213C18.9836 15.5775 19.6129 13.5348 19.4833 11.4683C19.3538 9.40185 18.4745 7.45369 17.0104 5.9896C15.5463 4.5255 13.5981 3.64616 11.5317 3.51665C9.46517 3.38715 7.42246 4.01638 5.78703 5.28623C4.1516 6.55608 3.03591 8.37921 2.64941 10.4134Z"
                stroke="#101828"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8 11H14"
                stroke="#101828"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8 13H14"
                stroke="#101828"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <a
            href="https://t.me/ECOS_BTC_Mining_bot"
            target="_blank"
            rel="noopener noreferrer"
            className="icon__svg"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              height="16"
              viewBox="0 0 19 16"
              fill="none"
            >
              <path
                d="M13.3197 6.22911L13.3198 6.22895C13.5147 6.04007 13.6667 5.84522 13.7536 5.65403C13.8232 5.50081 13.9285 5.1621 13.6822 4.89256C13.4432 4.63107 13.102 4.69083 12.939 4.73961C12.7351 4.80063 12.5142 4.92516 12.2871 5.09661C10.2721 6.6179 7.05481 8.9176 6.00747 9.55526C5.55208 9.83238 5.23625 9.97522 4.98277 10.043C4.74173 10.1074 4.53892 10.1088 4.29817 10.0687L4.29805 10.0686C3.25341 9.89481 2.29312 9.62676 1.51882 9.30553L1.51875 9.3055C0.821019 9.01616 0.828543 8.03984 1.52018 7.74854L16.4826 1.44856C16.6233 1.38934 16.7774 1.36891 16.9287 1.38941C17.0799 1.40991 17.223 1.47058 17.3429 1.56512C17.4628 1.65966 17.5551 1.7846 17.6103 1.92694C17.6655 2.06924 17.6816 2.22372 17.6568 2.37432L15.6724 14.4113C15.5294 15.2738 14.5892 15.7543 13.8119 15.3321C12.9255 14.8505 11.615 14.1119 10.4402 13.344C10.1468 13.1519 9.57051 12.7609 9.0992 12.3184C8.86235 12.0961 8.67103 11.8782 8.5534 11.6821C8.43131 11.4787 8.42771 11.3658 8.44021 11.3163L7.99582 11.2041L8.44007 11.3169C8.44003 11.317 8.44005 11.3169 8.44014 11.3167C8.44094 11.3142 8.44749 11.2942 8.46933 11.2531C8.49228 11.2099 8.52594 11.1548 8.57228 11.0872C8.6652 10.9518 8.79614 10.7852 8.96169 10.5911C9.29221 10.2035 9.73845 9.73251 10.2401 9.22543C10.9696 8.48799 11.7997 7.69079 12.5372 6.98255C12.8145 6.71619 13.0788 6.4624 13.3197 6.22911Z"
                stroke="#101828"
                strokeWidth="0.916667"
              />
            </svg>
          </a>
          <a
            href="https://api.whatsapp.com/send/?phone=%2B37493096516&text&type=phone_number&app_absent=0"
            target="_blank"
            rel="noopener noreferrer"
            className="icon__svg_fill"
          >
            <button>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
              >
                <g clipPath="url(#clip0_1316_9299)">
                  <path
                    d="M0.333496 20L1.48632 14.3304C0.810664 12.9632 0.462357 11.4572 0.469459 9.93201C0.469459 4.45766 4.92712 0 10.4015 0C15.876 0 20.3335 4.45766 20.3335 9.93201C20.3335 15.4064 15.876 19.864 10.4015 19.864C8.87783 19.8684 7.37393 19.5181 6.00893 18.8413L0.333496 20ZM6.14489 17.8481L6.29263 17.9249C7.56254 18.5815 8.97205 18.9222 10.4015 18.9182C15.3557 18.9182 19.3876 14.8862 19.3876 9.93201C19.3876 4.97778 15.3557 0.945848 10.4015 0.945848C5.44724 0.945848 1.41531 4.97778 1.41531 9.93201C1.41132 11.3616 1.75201 12.7709 2.40861 14.0408L2.48551 14.1886L1.54538 18.7881L6.14489 17.8481Z"
                    fill="#101828"
                  />
                  <path
                    d="M13.2037 15.6075H12.7662C8.33228 15.6075 4.72608 12.0013 4.72608 7.56737V7.12986C4.72538 6.37731 5.02554 5.65575 5.55969 5.12576L5.94991 4.73554C6.55871 4.12657 7.62285 4.12657 8.23183 4.73554L9.45566 5.95331C9.75946 6.2552 9.92971 6.66603 9.9285 7.09436C9.92712 7.52216 9.75721 7.93213 9.45566 8.2354L9.34326 8.34764C9.11169 8.5799 8.98196 8.8946 8.98265 9.22264C8.98386 9.55017 9.11342 9.86435 9.34326 10.0977L10.23 10.9844C10.6913 11.4455 11.5188 11.4455 11.986 10.9844L12.0982 10.872C12.7072 10.2631 13.7713 10.2631 14.3803 10.872L15.6039 12.1018C16.234 12.732 16.234 13.7536 15.6039 14.3837L15.2139 14.7739C14.6823 15.3096 13.9584 15.6098 13.2037 15.6075ZM7.09078 5.20249C6.9136 5.20231 6.74334 5.27246 6.61795 5.39768L6.22772 5.7879C5.87162 6.14123 5.67158 6.62221 5.67192 7.12397V7.56737C5.67521 11.484 8.84963 14.6584 12.7662 14.6617H13.2037C13.7055 14.662 14.1865 14.462 14.5398 14.1059L14.93 13.7156C15.0558 13.5904 15.1262 13.4202 15.1262 13.2428C15.1262 13.0653 15.0558 12.8952 14.93 12.7698L13.7122 11.546C13.4474 11.2938 13.0312 11.2938 12.7662 11.546L12.654 11.6584C11.7999 12.5115 10.4161 12.5115 9.56201 11.6584L8.67522 10.7716C8.26647 10.3597 8.0368 9.80304 8.0368 9.22264C8.03594 8.64381 8.2656 8.08853 8.67522 7.6796L8.78763 7.56737C8.91216 7.44145 8.98231 7.27154 8.98265 7.09436C8.983 6.917 8.91285 6.74692 8.78763 6.62135L7.56379 5.39768C7.43822 5.27246 7.26814 5.20231 7.09078 5.20249Z"
                    fill="#101828"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1316_9299">
                    <rect width="40" height="40" fill="white" transform="translate(0.333496)" />
                  </clipPath>
                </defs>
              </svg>
            </button>
          </a>
        </div>
        <div className="icons__actions">
          <button id="exit" className="icon__exit">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M5.125 17H11.875C12.1733 16.9997 12.4592 16.8791 12.6701 16.6649C12.881 16.4506 12.9997 16.1601 13 15.8571V14.1429H11.875V15.8571H5.125V3.14286H11.875V4.85714H13V3.14286C12.9997 2.83986 12.881 2.54937 12.6701 2.33512C12.4592 2.12087 12.1733 2.00035 11.875 2H5.125C4.82674 2.00035 4.54079 2.12087 4.32988 2.33512C4.11898 2.54937 4.00034 2.83986 4 3.14286V15.8571C4.00034 16.1601 4.11898 16.4506 4.32988 16.6649C4.54079 16.8791 4.82674 16.9997 5.125 17Z"
                fill="white"
              />
              <path
                d="M13.8811 12.1752L15.8733 10.0833H8V8.91667H15.8733L13.8811 6.82483L14.6667 6L18 9.5L14.6667 13L13.8811 12.1752Z"
                fill="white"
              />
            </svg>
          </button>
          <button className="icons__support">
            <a
              className="icons__text"
              href="https://ecoshelp.zendesk.com/hc/en-us/requests/new"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getTranslation('support', language)}
            </a>
          </button>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;

